// Module
var code = "<!-- ko foreach: links -->\r\n<bp-sidebar-link params=\"action: $data.action, url: $data.url, label: $data.label, icon: $data.icon, description: $data.description\"></bp-sidebar-link>\r\n<!-- /ko -->\r\n";
// Exports
module.exports = code;